/*========================================================================
 * $Id: getprofile.js 76458 2013-11-12 09:34:35Z jakob.praher $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define([
    "i18n/i18n",
    "api/v2/common",
    "backbone",
    "underscore",
    "model/readonlytree",
    "service/stub",
    "service/factory",
    "utils/clone"
  ], function(
    i18n,
    Common,
    Backbone,
    _,
    ReadOnlyTreeModel,
    Stub,
    ServiceFactory,
    clone
  ) {
  var Export = {};

  var ExportServiceStub = Export.ExportServiceStub = Stub.extend({
    path: "export",
    options: {defaultAjaxRequestTimeoutInMs: 60000},

    getDataType: function(channel, request) {
      var format = Stub.prototype.getDataType.apply(this, arguments);
      if (request != null && request.export_format) {
        format.responseType = "blob";
      }
      return format;
    },

    call: function(channel, request, responseObserver, options) {
      return Stub.prototype.call.apply(this, [channel, request, responseObserver, options]);
    }
  });
  
  var ExportOutputModel = Export.ExportOutputModel = ReadOnlyTreeModel.extend({

    initialize: function (options) {
      this.channel = options.channel;
      this.serviceStub = options.serviceStub;
    },

    parse: function (response) {      
      response = _.clone(response);
      // response.status_messages = Common.StatusMessages.parse(response.status_messages);
      return response;
    },

    merge: function (merged, rhs, options) {
      return merged;
    }
    
  });
  
  var ExportServiceFactory = Export.ServiceFactory = function() {}
  
  _.extend(ExportServiceFactory.prototype, ServiceFactory.prototype, {
      /*    createInput:  function(attrs,options) { return new GetProfileInputModel(attrs, options); },*/
    createStub:  function() {
      return new ExportServiceStub();
    },
    
    createModel:  function(channel, options) {
      options = options || {};
      options.channel = options.channel || channel;
      options.serviceStub = options.serviceStub || new ExportServiceStub();
      var model = new Export({}, options);
      return model;
    }
  });

  return Export;
})
